import { Empty } from "components/Empty";
import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import styled from "styled-components";
import { mq, device } from "lib/media-query";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    ${mq.to(device.TABLET)`
     grid-template-columns: 1fr;
  `};
    ${({ condensed }) => (condensed ? "grid-template-columns: 1fr" : "")}
`;

export const AantalCilindersFilter = ({ condensed }) => {
    const filterOptions = useFilter("aantalCilinders");
    const [value, , onChange] = useField("aantalCilinders");

    const options =
        filterOptions.map((option) => ({
            id: option,
            displayName: `${option}`,
            naam: `${option}`
        })) || [];

    return (
        <Grid condensed={condensed}>
            <FilterButtonGroup
                filterId="filter-aantal-cilinders"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                datalayerKey="aantalCilinders"
                columns={condensed ? 2 : 8}
            />
            <Empty />
        </Grid>
    );
};
